// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:host {
  display: block;
  pointer-events: auto;
}

.row-details-tooltip {
  pointer-events: auto;
  cursor: default;
}

.row-details-tooltip {
  width: 360px;
  max-width: min(360px, calc(100vw - 32px));
  overflow: hidden;

  color: var(--ca-text-primary, #172033);
  background: var(--ca-surface, #ffffff);

  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 10px);

  box-shadow:
    0 8px 24px rgba(4, 27, 56, 0.16),
    0 2px 6px rgba(4, 27, 56, 0.08);

  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
}

.tooltip-header {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 14px 16px;

  color: #ffffff;
  background: var(--ca-primary, #0e2e80);

  border-bottom: 1px solid var(--ca-primary-dark, #0d2863);
}

.tooltip-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;

  flex-shrink: 0;

  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);

  border-radius: 8px;

  font-size: 16px;
}

.tooltip-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.tooltip-body {
  display: flex;
  flex-direction: column;
  gap: 0;

  max-height: 320px;
  overflow-y: auto;

  padding: 8px 16px;
}

.detail-row {
  display: grid;
  grid-template-columns: minmax(110px, 0.85fr) minmax(0, 1.15fr);
  align-items: start;
  gap: 16px;

  padding: 11px 0;

  border-bottom: 1px solid var(--ca-border, #dfe4ec);

  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  color: var(--ca-text-secondary, #657087);

  font-size: 13px;
  font-weight: 500;

  overflow-wrap: anywhere;
}

.detail-value {
  color: var(--ca-text-primary, #172033);

  font-size: 14px;
  font-weight: 500;

  text-align: right;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.empty-details {
  padding: 18px 0;

  color: var(--ca-text-secondary, #657087);

  font-size: 14px;
  text-align: center;
}

@media (max-width: 480px) {
  .row-details-tooltip {
    width: 300px;
  }

  .detail-row {
    grid-template-columns: minmax(90px, 0.8fr) minmax(0, 1.2fr);
    gap: 10px;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/app/shared/table/main-table/row-tooltip.component.ts"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;;EAEhB,sCAAsC;EACtC,sCAAsC;;EAEtC,2CAA2C;EAC3C,wCAAwC;;EAExC;;mCAEiC;;EAEjC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;;EAElB,cAAc;EACd,sCAAsC;;EAEtC,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,cAAc;EACd,qCAAqC;;EAErC,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;;EAEN,iBAAiB;EACjB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,kBAAkB;EAClB,SAAS;;EAET,eAAe;;EAEf,kDAAkD;;EAElD;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,wCAAwC;;EAExC,eAAe;EACf,gBAAgB;;EAEhB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;;EAEtC,eAAe;EACf,gBAAgB;;EAEhB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;;EAEf,wCAAwC;;EAExC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF","sourcesContent":["\n:host {\n  display: block;\n  pointer-events: auto;\n}\n\n.row-details-tooltip {\n  pointer-events: auto;\n  cursor: default;\n}\n\n.row-details-tooltip {\n  width: 360px;\n  max-width: min(360px, calc(100vw - 32px));\n  overflow: hidden;\n\n  color: var(--ca-text-primary, #172033);\n  background: var(--ca-surface, #ffffff);\n\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 10px);\n\n  box-shadow:\n    0 8px 24px rgba(4, 27, 56, 0.16),\n    0 2px 6px rgba(4, 27, 56, 0.08);\n\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.tooltip-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  padding: 14px 16px;\n\n  color: #ffffff;\n  background: var(--ca-primary, #0e2e80);\n\n  border-bottom: 1px solid var(--ca-primary-dark, #0d2863);\n}\n\n.tooltip-header-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 30px;\n  height: 30px;\n\n  flex-shrink: 0;\n\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.16);\n\n  border-radius: 8px;\n\n  font-size: 16px;\n}\n\n.tooltip-title {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n\n.tooltip-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n\n  max-height: 320px;\n  overflow-y: auto;\n\n  padding: 8px 16px;\n}\n\n.detail-row {\n  display: grid;\n  grid-template-columns: minmax(110px, 0.85fr) minmax(0, 1.15fr);\n  align-items: start;\n  gap: 16px;\n\n  padding: 11px 0;\n\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.detail-label {\n  color: var(--ca-text-secondary, #657087);\n\n  font-size: 13px;\n  font-weight: 500;\n\n  overflow-wrap: anywhere;\n}\n\n.detail-value {\n  color: var(--ca-text-primary, #172033);\n\n  font-size: 14px;\n  font-weight: 500;\n\n  text-align: right;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.empty-details {\n  padding: 18px 0;\n\n  color: var(--ca-text-secondary, #657087);\n\n  font-size: 14px;\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .row-details-tooltip {\n    width: 300px;\n  }\n\n  .detail-row {\n    grid-template-columns: minmax(90px, 0.8fr) minmax(0, 1.2fr);\n    gap: 10px;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
